"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TopBar = void 0;
const ac_1 = require("@app/ac");
const ui_1 = require("@app/component/ui");
const controls_1 = __importDefault(require("@app/component/ui/calendar/common/controls"));
const filters_1 = __importDefault(require("@app/component/ui/calendar/common/controls/filters"));
const store_1 = require("@app/store");
const util_1 = require("@app/util");
const moment_1 = __importDefault(require("moment"));
const react_1 = __importDefault(require("react"));
const use_remember_calendar_filters_1 = require("./util/use-remember-calendar-filters");
// import './index.scss'
require("./schedule-bar.scss");
const _isMobileOrTouchscreen = () => {
    if (window.matchMedia('only screen and (max-device-width: 768px)').matches) {
        return true;
    } // mobile devices
    if (window.matchMedia('only screen and (pointer: coarse)').matches)
        return true; // touch screens
    return false;
};
const TopBarComponent = ({ countWarningsByType, warningCounts }) => {
    const dispatch = (0, store_1.useRootDispatch)();
    const view = (0, store_1.useRootSelector)((state) => state.calendar?.view);
    const date = (0, store_1.useRootSelector)((state) => state.calendar?.date);
    const changedShiftsOnWS = (0, store_1.useRootSelector)((state) => state.calendar?.changedShiftsCount ?? 0);
    const isLoadingShiftsOrCalendar = (0, store_1.useRootSelector)((state) => state.loading.includes('load-shifts') || state.loading.includes('set-calendar'));
    const [filtersActive, setFiltersActive] = react_1.default.useState(false);
    const [width, setWidth] = react_1.default.useState();
    // restores this workspace's calendar filters and keeps them saved - has to live here rather
    // than in <Filters />, which is only mounted while the filters panel is open
    (0, use_remember_calendar_filters_1.useRememberCalendarFilters)();
    const resizeObserverRef = react_1.default.useRef(null);
    const statefulRef = react_1.default.useCallback((node) => {
        if (resizeObserverRef.current) {
            resizeObserverRef.current.disconnect();
            resizeObserverRef.current = null;
        }
        if (!(0, util_1.isValue)(node))
            return;
        const resizeObserver = new ResizeObserver(() => {
            setWidth(node.getBoundingClientRect().width);
        });
        resizeObserver.observe(node);
        setWidth(node.getBoundingClientRect().width);
        resizeObserverRef.current = resizeObserver;
    }, []);
    if (filtersActive) {
        return (react_1.default.createElement("div", { className: 'ds-schedule-bar is-filters-display' },
            react_1.default.createElement(filters_1.default, { setFiltersActive: setFiltersActive })));
    }
    return (react_1.default.createElement("div", { className: 'ds-schedule-bar' },
        react_1.default.createElement("div", { className: 'ds-schedule-bar-top' },
            react_1.default.createElement("div", { className: 'ds-schedule-view-controls' },
                react_1.default.createElement("div", { className: 'ds-schedule-title ds-title' }, (0, util_1.t)('CALENDAR')),
                react_1.default.createElement(ui_1.Switcher, { size: ui_1.Switcher.SIZES.COMPACT, options: [
                        { label: (0, util_1.t)('DAY'), value: 'day' },
                        { label: (0, util_1.t)('WEEK'), value: 'week' },
                        { label: (0, util_1.t)('MONTH'), value: 'month' },
                    ], value: view || undefined, onSelect: async (v) => {
                        await dispatch((0, ac_1.setCalendar)({ view: v }, false));
                    } }),
                react_1.default.createElement(ui_1.Spacing, { size: ui_1.Spacing.SIZES.SIZE_12, type: ui_1.Spacing.TYPES.HORIZONTAL },
                    view === 'month' && (react_1.default.createElement(ui_1.MonthSelect, { returnType: ui_1.MonthSelect.RETURN_TYPES.STRING, style: ui_1.MonthSelect.STYLES.BORDERLESS, value: date, onChange: async (v) => {
                            await dispatch((0, ac_1.setCalendar)({
                                date: (0, moment_1.default)(v, 'YYYY-MM')
                                    .endOf('month')
                                    .format('YYYY-MM-DD'),
                            }, false));
                        } })),
                    view === 'day' && (react_1.default.createElement(ui_1.Tooltip, { clickable: true, anchor: react_1.default.createElement(ui_1.Button, { bold: true, style: ui_1.Button.STYLES.LIGHT },
                            (0, moment_1.default)(date).format(_isMobileOrTouchscreen() ? 'D.M.' : 'D. MMMM'),
                            react_1.default.createElement("div", { className: 'ds-select-caret' })) },
                        react_1.default.createElement(ui_1.DaySelect
                        // @ts-expect-error
                        , { 
                            // @ts-expect-error
                            singleDaySelection: true, value: (0, moment_1.default)(date), onChange: async (v) => {
                                if (v?.length)
                                    await dispatch((0, ac_1.setCalendar)({ date: v[0] }, false));
                            } }))),
                    view === 'week' && (react_1.default.createElement(ui_1.Tooltip, { clickable: true, anchor: react_1.default.createElement(ui_1.Button, { style: ui_1.Button.STYLES.LIGHT, bold: true },
                            (0, moment_1.default)(date).startOf('week').format('D.'),
                            (0, moment_1.default)(date).startOf('week').month() !==
                                (0, moment_1.default)(date).endOf('week').month()
                                ? (0, moment_1.default)(date).startOf('week').format('M.')
                                : null,
                            ' - ',
                            (0, moment_1.default)(date).endOf('week').format('D.M.'),
                            react_1.default.createElement("div", { className: 'ds-select-caret' })) },
                        react_1.default.createElement(ui_1.WeekSelect
                        // @ts-expect-error
                        , { 
                            // @ts-expect-error
                            value: (0, moment_1.default)(date).startOf('week'), onChange: async (v) => await dispatch((0, ac_1.setCalendar)({ date: v }, false)) })))),
                react_1.default.createElement(ui_1.Button, { testid: 'previous-month-button', bold: true, style: ui_1.Button.STYLES.LIGHT, disabled: isLoadingShiftsOrCalendar, onClick: async () => {
                        if ((0, util_1.isValue)(view) && (0, util_1.isValue)(date)) {
                            const newDate = (0, moment_1.default)(date)
                                .add(-1, `${view}s`)
                                .startOf(view)
                                .format('YYYY-MM-DD');
                            await dispatch((0, ac_1.setCalendar)({ date: newDate }, false));
                        }
                    }, ico: ui_1.Icon.ICONS.arrowLeft }),
                react_1.default.createElement(ui_1.Spacing, { size: ui_1.Spacing.SIZES.SIZE_2, type: ui_1.Spacing.TYPES.HORIZONTAL },
                    react_1.default.createElement(ui_1.Button, { bold: true, style: ui_1.Button.STYLES.LIGHT, onClick: async () => {
                            const newDate = (0, moment_1.default)().format('YYYY-MM-DD');
                            await dispatch((0, ac_1.setCalendar)({ date: newDate }, false));
                        }, label: (0, util_1.t)('TODAY'), testid: 'today-button' })),
                react_1.default.createElement(ui_1.Button, { testid: 'next-month-button', disabled: isLoadingShiftsOrCalendar, style: ui_1.Button.STYLES.LIGHT, bold: true, onClick: async () => {
                        if ((0, util_1.isValue)(view) && (0, util_1.isValue)(date)) {
                            const newDate = (0, moment_1.default)(date)
                                .add(1, `${view}s`)
                                .startOf(view)
                                .format('YYYY-MM-DD');
                            await dispatch((0, ac_1.setCalendar)({ date: newDate }, false));
                        }
                    }, ico: ui_1.Icon.ICONS.arrowRight }))),
        changedShiftsOnWS > 0 ? (react_1.default.createElement("div", { className: 'ds-schedule-btn-announce-wrapper', style: { width } },
            react_1.default.createElement(ui_1.Flex, null,
                react_1.default.createElement(ui_1.Icon, { ico: 'send', color: ui_1.Icon.COLORS.WHITE }),
                react_1.default.createElement(ui_1.Spacing, { size: ui_1.Spacing.SIZES.SIZE_8, type: ui_1.Spacing.TYPES.HORIZONTAL }),
                react_1.default.createElement(ui_1.Text, { color: ui_1.Text.COLORS.WHITE, weight: ui_1.Text.WEIGHTS.BOLD }, (0, util_1.t)('NOT_PUBLISH_X_CHANGES', { x: changedShiftsOnWS }))),
            react_1.default.createElement(ui_1.Button, { testid: 'open-publish-changes-modal-button', dataTour: 'schedule-publish', size: ui_1.Button.SIZES.SMALL, style: ui_1.Button.STYLES.CONTAINED, color: ui_1.Button.COLORS.WHITE, bold: true, onClick: async () => {
                    await dispatch((0, ac_1.setModal)('publish-changes'));
                }, label: (0, util_1.t)('ANNOUNCE_SHORTER') }))) : (react_1.default.createElement("div", null)),
        react_1.default.createElement(controls_1.default, { warningCounts: warningCounts, countWarningsByType: countWarningsByType, setFiltersActive: setFiltersActive, controlsRef: statefulRef })));
};
exports.TopBar = react_1.default.memo(TopBarComponent);
